import { HeaderUserComponent } from './header-user.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreCardModule } from '@core/components/core-card/core-card.module';
import { CoreCommonModule } from '@core/common.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';

const routes = [
  {
    path: '',
    component: HeaderUserComponent,
    data: { animation: 'header-user' },
  },
];

@NgModule({
  declarations: [HeaderUserComponent],
  exports: [HeaderUserComponent],
  imports: [
    CommonModule,
    NgbModule,
    TranslateModule,
    CoreCommonModule,
    CoreCardModule,
    NgSelectModule,
 
  ],
})
export class HeaderUserModule {}
